import {Component, OnDestroy, OnInit} from '@angular/core';

@Component({
  selector: 'app-message-right-panel',
  templateUrl: './message-right-panel.component.html',
  styleUrls: ['./message-right-panel.component.css']
})
export class MessageRightPanelComponent implements OnInit, OnDestroy {
  messageText: string;


  constructor() {

  }

  ngOnInit() {
    this.messageText = "Thank you, we have informed the concerned person"
  }

  ngOnDestroy() {
  }

}
